export interface Provider {
  name: string;
  icon: string;
  scope: string;
  url: string;
}
